import { render, staticRenderFns } from "./RoleCreateView.vue?vue&type=template&id=fa0159ba&scoped=true&"
import script from "./RoleCreateView.vue?vue&type=script&lang=js&"
export * from "./RoleCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0159ba",
  null
  
)

export default component.exports